module.exports = __webpack_public_path__ + "img/Image.c3d00712.svg";